import { foundationErrorDialogShadowOptions as shadowOptions, ErrorDialog as FoundationErrorDialog, errorDialogTemplate as template, foundationErrorDialogStyles as styles, } from '@genesislcap/foundation-ui';
/**
 * @tagname %%prefix%%-error-dialog
 */
export class ErrorDialog extends FoundationErrorDialog {
}
/**
 * The zero ErrorDialog
 *
 * @public
 * @remarks
 * HTML Element: <zero-error-dialog>
 */
export const zeroErrorDialog = ErrorDialog.compose({
    baseName: 'error-dialog',
    styles,
    template,
    shadowOptions,
});
